<template>
  <div class="proofingProgess">
    <div class="proofingProgess__control">
      <el-button @click="handlePrint">打印</el-button>
    </div>
    <div class="proofingProgess__content">
      <div
        class="proofingProgess__print"
        v-for="(item, $index) in list"
        :key="`base-print-qrcode-${$index}`"
      >
        <base-print-qrcode :width="75" :height="75" :url="item.materialCode">
          <el-row v-if="$route.query.page === 'fabric-warehouse'">
            <p class="base-print-qrcode__line">
              物料编号：{{ item.materialCode }}
            </p>
            <p class="base-print-qrcode__line">
              供应商编号：{{ item.vendorCode }}
            </p>
            <p class="base-print-qrcode__line">
              供应商名称：{{ item.vendorName }}
            </p>
            <p class="base-print-qrcode__line">
              供应商物料编号：{{ item.s024 }}
            </p>
            <p class="base-print-qrcode__line">
              关联面料号：{{ item.relatedMaterialCode }}
            </p>
            <p
              class="fabric-warehouse-base-print-qrcode__line"
              style="word-break: break-all"
            >
              面料名称：{{ item.materialDescCn }}
            </p>
          </el-row>
          <el-row v-else>
            <p class="base-print-qrcode__line">
              面料组别：{{ item.materialCode }}
            </p>
            <p class="base-print-qrcode__line">
              描述：{{ item.materialDescCn }}
            </p>
            <p class="base-print-qrcode__line">
              面料编号：{{ item.relateMaterialCode }}
            </p>
          </el-row>
        </base-print-qrcode>
      </div>
    </div>
  </div>
</template>

<script>
import basePrintQrcode from "components/base-control/modules/base-print-qrcode.vue";
import printWindow from "src/common/print";
export default {
  name: "proofing-progess",
  components: {
    basePrintQrcode,
  },
  computed: {},
  mounted() {
    if (this.$route.query.page === "fabric-warehouse") {
      let ids = this.$route.query.ids
      const params = JSON.parse(
        window.sessionStorage.getItem("fabric-warehouse")
      );
      this.POST_PRINTDATA({
        idList: ids.split(',')
      });
    } else {
      const params = JSON.parse(
        window.sessionStorage.getItem("proofingProgess")
      );
      this.$apis.P16_proofingprogressdata.MASTERDATA_MATERIAL_PRINTDATA(params)
        .done((res) => {
          console.log(res);
          this.list = res.list;
        })
        .fail((err) => {
          consoel.log(err);
        });
    }
  },
  data() {
    return {
      list: [
        {
          materialCode: "T010101-0004",
          materialDescCn: "1",
          relatedMaterialCode: "",
          s024: "12",
          vendorCode: "S430L2_01",
          vendorName: "新化",
        },
      ],
    };
  },
  methods: {
    handlePrint() {
      printWindow(
        ".proofingProgess__content",
        "",
        "muilt-qrcode",
        "proofingProgess__content"
      );
    },
    POST_PRINTDATA(params) {
      this.$apis.autoAPi
        .POST_AD_MF_MASTERIAL_PRINT({
          ...params,
        })
        .done((res) => {
          this.list = res.data;
        })
        .fail((err) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/sass/index";
.proofingProgess {
  position: fixed;
  overflow-y: scroll;
  height: 100vh;
  width: 100vw;
  padding: 20px;
  background-color: white;
  .proofingProgess__control {
    margin-bottom: 20px;
  }
  .proofingProgess__content {
    display: flex;
    flex-wrap: wrap;
  }
  .proofingProgess__print {
    /*width: 60mm;*/
    width: 131mm;
    height: 30.5mm;
    margin-right: 20px;
    /*page-break-after: always;*/
  }
  .fabric-warehouse-base-print-qrcode__line {
    font-size: 3mm;
    /*word-break: keep-all;*/
    word-break: break-all;
    margin: 0;
  }
  .base-print-qrcode__line {
    font-size: 3mm;
    word-break: keep-all;
  }
  .fabric-warehouse-base-print-qrcode__line {
    font-size: 3mm;
    /*word-break: keep-all;*/
    word-break: break-all;
  }
}
</style>

<style lang="scss">
@media print {
  .proofingProgess__print {
    page-break-inside: avoid !important;
    page-break-before: unset !important;
  }
}
</style>
